import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgModule } from '@angular/core';

import { FooterModule } from '@component/footer';
import { HeroContainerModule } from '@component/hero-container';
import { IconWallModule } from '@component/icon-wall';
import { NetworkInfrastructureModule } from '@component/network-infrastructure';
import { ProductCardModule } from '@component/product-card/product-card.module';
import { StatisticalHighlightsModule } from '@component/statistical-highlights';

import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { ProductsComponent } from './products/products.component';

@NgModule({
  declarations: [HomeComponent, ProductsComponent],
  imports: [
    CommonModule,
    FooterModule,
    HeroContainerModule,
    HomeRoutingModule,
    IconWallModule,
    InlineSVGModule,
    NetworkInfrastructureModule,
    ProductCardModule,
    StatisticalHighlightsModule
  ]
})
export class HomeModule {}
